import axios from 'axios';

// الحصول على معرف الفرع النشط للمستخدم الحالي
export const getCurrentUserBranch = async (): Promise<string | null> => {
  try {
    // تحقق من وجود جلسة نشطة (تم تسجيل الدخول مؤخرًا)
    const sessionActive = localStorage.getItem('session_refreshed');
    const currentTime = new Date().getTime();
    const sessionTimestamp = parseInt(sessionActive || '0');
    
    // إذا مر أقل من 30 ثانية على تسجيل الدخول، قم بتجاهل التخزين المحلي
    const isRecentLogin = (currentTime - sessionTimestamp) < 30000;
    
    // أولاً، محاولة الحصول على الفرع من التخزين المحلي (فقط إذا لم يكن تسجيل دخول حديث)
    // مهم: نستخدم نفس المفتاح الذي يستخدمه AuthContext (activeBranchId)
    const storedBranchId = localStorage.getItem('activeBranchId');
    if (!isRecentLogin && storedBranchId && storedBranchId.match(/^[0-9a-fA-F]{24}$/)) {
      console.log('استخدام الفرع المخزن محلياً:', storedBranchId);
      // إرسال رأس x-branch-id للإشارة إلى الفرع المحدد
      const response = await axios.get('/api/users/me/active-branch', {
        headers: { 'x-branch-id': storedBranchId }
      });
      
      if (response.data && response.data.branchId) {
        // تخزين الفرع النشط المؤكد في التخزين المحلي
        localStorage.setItem('activeBranchId', response.data.branchId);
        console.log('تم تأكيد الفرع من الخادم:', response.data.branchId, response.data.source);
        return response.data.branchId;
      }
    }

    // إذا كان تسجيل دخول حديث أو لم يكن هناك فرع مخزن، جلب الفرع النشط من الخادم
    console.log('طلب الفرع النشط من الخادم بدون تحديد فرع مسبق');
    
    try {
      const response = await axios.get('/api/users/me/active-branch');
    if (response.data && response.data.branchId) {
      // تخزين الفرع النشط في التخزين المحلي للاستخدام المستقبلي
      localStorage.setItem('activeBranchId', response.data.branchId);
      console.log('تم جلب الفرع النشط من الخادم:', response.data.branchId, response.data.source);
      
      // إذا كان تسجيل دخول حديث، قم بإزالة علم الجلسة
      if (isRecentLogin) {
        localStorage.removeItem('session_refreshed');
      }
      
      return response.data.branchId;
    }
    
    } catch (innerError) {
      console.log('خطأ في جلب الفرع النشط، محاولة استخدام فرع افتراضي');
      
      // رجوع قائمة الفروع للمستخدم
      try {
        const branchesResponse = await axios.get('/api/branches');
        if (branchesResponse.data && branchesResponse.data.branches && branchesResponse.data.branches.length > 0) {
          console.log('تم جلب قائمة الفروع بنجاح، عدد الفروع:', branchesResponse.data.branches.length);
          
          // استخدم أول فرع كفرع افتراضي بدلاً من رمي خطأ
          const defaultBranch = branchesResponse.data.branches[0]._id;
          console.log('استخدام الفرع الأول كفرع افتراضي:', defaultBranch);
          
          // حفظ الفرع الافتراضي في التخزين المحلي
          localStorage.setItem('activeBranchId', defaultBranch);
          
          return defaultBranch;
        }
      } catch (branchError) {
        console.error('خطأ في جلب قائمة الفروع:', branchError);
      }
      
      // إذا وصلنا إلى هنا، فلا يوجد فروع أو حدث خطأ في جلبها
      console.warn('لم يتم العثور على أي فرع متاح');
      throw new Error('NoBranchesAvailable');
    }
  } catch (error: any) {
    console.error('خطأ في جلب معرف الفرع النشط:', error);

    // تحقق مما إذا كان الخطأ من نوع 400 وسببه عدم وجود فرع نشط
    if (axios.isAxiosError(error) && error.response?.status === 400 &&
        error.response?.data?.needBranchSelection) {
      // بدلاً من رمي خطأ، محاولة جلب قائمة الفروع واستخدام الفرع الأول
      try {
        const branchesResponse = await axios.get('/api/branches');
        if (branchesResponse.data && branchesResponse.data.branches && branchesResponse.data.branches.length > 0) {
          console.log('تم جلب قائمة الفروع بنجاح، عدد الفروع:', branchesResponse.data.branches.length);
          
          // استخدم أول فرع كفرع افتراضي
          const defaultBranch = branchesResponse.data.branches[0]._id;
          console.log('استخدام الفرع الأول كفرع افتراضي (من معالجة الخطأ):', defaultBranch);
          
          // حفظ الفرع الافتراضي في التخزين المحلي
          localStorage.setItem('activeBranchId', defaultBranch);
          
          return defaultBranch;
        }
      } catch (branchError) {
        console.error('خطأ في جلب قائمة الفروع من معالجة الخطأ:', branchError);
      }
      
      throw new Error('NoBranchSelected');
    }
    
    // في حالة خطأ NoBranchesAvailable، نمرر الخطأ للمعالجة في المستوى الأعلى
    if (error.message === 'NoBranchesAvailable') {
      throw error;
    }
    
    // في حالة حدوث أي خطأ آخر، نرجع null بدلاً من استخدام قيمة افتراضية غير موجودة
    return null;
  }
  
  // تأكد من أن جميع مسارات الدالة تحتوي على return
  return null;
};

// تعيين فرع نشط
export const setActiveBranch = async (branchId: string): Promise<boolean> => {
  try {
    if (!branchId) return false;
    
    // تخزين الفرع النشط في التخزين المحلي
    localStorage.setItem('activeBranchId', branchId);
    console.log('تم تعيين الفرع النشط:', branchId);
    return true;
  } catch (error) {
    console.error('خطأ في تعيين الفرع النشط:', error);
    return false;
  }
};

export default {
  getCurrentUserBranch
};